export default __webpack_public_path__ + "static/media/Trenzada.c4bb1164.jpg";